import { ShieldOff } from 'lucide-react';
import { useNavigate } from '@tanstack/react-router';

import { Button } from '@/components/ui/button';

export function NoPermission() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center gap-4 p-12 text-muted-foreground">
      <ShieldOff className="h-12 w-12" />
      <h2 className="text-lg font-semibold text-foreground">Access Denied</h2>
      <p className="text-sm text-center max-w-md">
        You don&apos;t have permission to access this page. Contact your administrator to request access.
      </p>
      <Button variant="outline" onClick={() => navigate({ to: '/' })}>
        Go to Dashboard
      </Button>
    </div>
  );
}
